import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { ContentEpisodesRelayResponseDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RelayEpisodeApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const DEFAULT_LIMIT = 1000;
const InitialParams = { limit: DEFAULT_LIMIT, offset: 0 };

const getNextPageParam = (lastGroup: ContentEpisodesRelayResponseDto, allGroups: ContentEpisodesRelayResponseDto[]) => {
  if ((lastGroup.episodeIds?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + (current.episodeIds?.length ?? 0), 0);
};

export const useGetRelayContentEpisodesInfiniteQuery = (contentId: number, orderType: EpisodeOrderType) =>
  useInfiniteQuery<ContentEpisodesRelayResponseDto>({
    queryKey: relayQueryKey.contentEpisodeList(contentId, orderType),
    queryFn: ({ pageParam = 0 }) =>
      RelayEpisodeApi.getContentEpisodes(contentId, orderType, { ...InitialParams, offset: pageParam as number }),
    initialPageParam: 0,
    getNextPageParam,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  });
